const origin = '/api';

export default {
	admin: {
		dealsReviews: {
			get: `${origin}/admin/deals/`,
		},
		deals: {
			get: `${origin}/admin/deals/`,
		},
		posts: {
			get:     `${origin}/posts/`,
			approve: (id) => `${origin}/posts/${id}/approve/`,
			delete:  (id) => `${origin}/posts/${id}/`,
		},
		users: {
			get:  (id) => `${origin}/users/${id}/`,
			edit: (id) => `${origin}/users/${id}/`,
		},
		agents: {
			requests: {
				get:    `${origin}/admin/agent-requests/`,
				accept: (id) => `${origin}/admin/agent-requests/${id}/accept/`,
				reject: (id) => `${origin}/admin/agent-requests/${id}/reject/`,
			},
			certified: {
				get:    `${origin}/users/`,
				revoke: (id) => `${origin}/users/${id}/`,
			},
			listed: {
				get:    `${origin}/users/`,
				revoke: (id) => `${origin}/users/${id}/`,
			},
		},
		videoGuides: {
			get: 	`${origin}/admin/video-guides/`,
			post:	`${origin}/admin/video-guides/bulk_update/`,
		}
	},
	deal: {
		images: {
			upload:      `${origin}/deals-images/`,
			get:         (id) => `${origin}/deals/${id}/images`,
			remove:      (id) => `${origin}/deals-images/${id}`,
			makeDefault: (id) => `${origin}/deals-images/${id}/make-default/`,
		},
		get:     (id) => `${origin}/deals/${id}`,
		tenants: {
			get:  (id) => `${origin}/deals/${id}/tenants/`,
			post: (id) => `${origin}/deals/${id}/tenants/`,
		},
		maintenance: {
			get:         (id) => `${origin}/deals/${id}/sections/`,
			post:        (id) => `${origin}/deals/${id}/sections/`,
			attachments: {
				post:   (id) => `${origin}/sections/${id}/add-attachment/`,
				delete: (id) => `${origin}/section-attachments/${id}/`,
				patch:  (id) => `${origin}/section-attachments/${id}/`,
			},
		},
		amortization: {
			annually: {
				get: (id) => `${origin}/deals/${id}/amortization/annually/`,
			},
			monthly: {
				get: (id) => `${origin}/deals/${id}/amortization/monthly/`,
			},
		},
	},
	deals: {
		get:    `${origin}/deals/`,
		my:     `${origin}/deals/my/`,
		latest: `${origin}/public-deals/`,
	},
	publicDeals: {
		get:          `${origin}/public-deals/`,
		autocomplete: `${origin}/deals-autocomplete/`,
		makePrivate:  (id) => `${origin}/public-deals/${id}/make-private/`,
	},
	publicProfile: {
		get: (id) => {
			if (id) {
				return `${origin}/public-profile/${id}/`;
			}
			return `${origin}/public-profile/`;
		},
		toggleFollow: (id) => {
			return `${origin}/public-profile/${id}/follow/`;
		},
		getFollowers: (id) => {
			return `${origin}/public-profile/${id}/followers/`;
		},
		getIFollow: (id) => {
			// need create new api
			return `${origin}/public-profile/${id}/followed/`;
		},
	},
	rolodex: {
		get: `${origin}/rolodex/`,
	},
	myPortfolio: {
		get: `${origin}/portfolio/`,
	},

	successCriteria: {
		get: `${origin}/success-criteria/`,
		put: `${origin}/success-criteria/`,
	},
	successStories: {
		get: `${origin}/success-stories/`,
	},
	main: {
		statuses: {
			get: `${origin}/statuses/`,
		},
	},
	billing: {
		transactions:  `${origin}/transactions/`,
		subscriptions:  {
			get:    `${origin}/subscription/`
		}
	},
	profile: {
		get:            `${origin}/users/current/`,
		set:            `${origin}/users/current/`,
		changePassword: `${origin}/users/change-password/`,
		subscription:   {
			get:    `${origin}/v1/users/current/subscription/`,
			cancel: `${origin}/v1/users/current/subscription/cancel/`,
		},
		delete:         `${origin}/v1/users/current/`,
	},
	markets: {
		get:         `${origin}/markets/`,
		getById:      (id) => {
			return `${origin}/markets/${id}/`;
		},
		sendMessage: (id) => {
			return `${origin}/markets/${id}/send-message/`;
		},
	},
	marketSettings: {
		get: (id) => {
			return `${origin}/markets/${id}/settings/`;
		},
		set: (id) => {
			return `${origin}/markets/${id}/settings/`;
		},
	},
	marketPermissions: {
		get: (id) => {
			return `${origin}/markets/${id}/permissions/`;
		},
	},
	contacts: {
		get:      `${origin}/contacts/`,
		save:     `${origin}/contacts/`,
		getTypes: `${origin}/contacts/choices/`,
		getById:  (id) => {
			return `${origin}/contacts/${id}/`;
		},
	},
	choices: {
		cities:     `/choices/cities`,
		regions:    `/choices/regions`,
		subregions: `/choices/subregions`,
	},
	feed: {
		get: `${origin}/feed/`,
	},
	posts: {
		get:      `${origin}/posts/`,
		create:   `${origin}/posts/`,
		complain: (id) => `${origin}/posts/${id}/complain/`,
		delete:   (id) => `${origin}/posts/${id}/`,
		comments: {
			get: (id) => {
				if (id) {
					return `${origin}/comments/${id}/`;
				}
				return `${origin}/comments/`;
			},
			create:      (id) => `${origin}/posts/${id}/comment/`,
			reply:       (id) => `${origin}/comments/${id}/reply/`,
			replyDelete: (id) => `${origin}/comments-replies/${id}/`,
			delete:      (id) => `${origin}/comments/${id}/`,
		},
	},
	configure: {
		getAgents:  (id) => `/choices/agents${id ? '?q=' + id : ''}`,
		getLeaders: (id) => `/choices/leaders${id ? '?q=' + id : ''}`,
	},
	uploadFile:       () => `${origin}/upload-file/`,
	subscriptionList: {
		get: `${origin}/v1/prices/`
	}
};
